(function () {
    'use strict';

    angular
        .module('recommendationModule')
        .controller('grcRecommendationFullController', Controller);

    Controller.$inject = ['$rootScope', '$scope', '$state', 'notificationService', 'grcRecommendationService', 'followUpService', 'historyCtxtService', '$modal'];

    function Controller($rootScope, $scope, $state, notificationService, grcRecommendationService, followUpService, historyCtxtService, $modal) {

        var recommendationBeforeChanges = $scope.boxModel;
        $scope.recommendation = _.cloneDeep(recommendationBeforeChanges);
        $scope.lookupAttributes = $scope.boxContext.LookupAttributes;

        $scope.view = {};
        $scope.ctrlCtxt = {};

        // Page is dirty
        $scope.pageIsDirty = function () {
            $rootScope.$broadcast('page-is-dirty');
            $scope.ctrlCtxt.needSaveChanges = true;
        };
        $scope.pageIsNotDirty = function () {
            $rootScope.$broadcast('page-is-not-dirty');
            $scope.ctrlCtxt.needSaveChanges = false;
        };

        // Get Lookups
        grcRecommendationService.getRecommendationLookups()
            .then(function (lookups) {
                $scope.recommendationLookups = lookups;
            });

        // Get FollowUps
        if (!_.isUndefined($scope.recommendation.RecommendationID)) {
            if ($scope.recommendation.HasRecommendationComment_View) {
                grcRecommendationService.getFollowUpsByRecommendationID($scope.recommendation)
                .then(function (followUps) {
                    $scope.currentFollowUps = followUps;
                });
            }
        }

        // Show Reset Action?
        $scope.showResetAction = function (form) {
            if (form.$invalid) return false;


            return $scope.ctrlCtxt.needSaveChanges;
        };

        // Edit Model Part
        $scope.editModelPart = function (partName) {

            if (!$scope.recommendation.HasRecommendation_Edit) return;

            // Modal to show
            var modalScope = $scope.$new(true);
            modalScope.recommendation = _.cloneDeep($scope.recommendation);

            var showModal = $modal({
                scope: modalScope,
                template: '/app/shared/grc/recommendation/grcRecommendationEdit.' + partName + '.modal.tpl.html',
                placement: 'center'
            });

            // Close Modal
            modalScope.close = function () {
                showModal.$promise.then(showModal.hide);
            };

            // On Save
            modalScope.onSave = function () {
                modalScope.close();
                notificationService.notify('Your changes have been saved');
                $scope.pageIsNotDirty();
                $state.reload();
            };
        };

        // Add owner
        $scope.addOwner = function (owner) {
        
            if (_.isUndefined($scope.recommendation.OwnerList)) {
                $scope.recommendation.OwnerList = [];
            }

             $scope.recommendation.OwnerList.push(owner);
        };

        // Remove owner
        $scope.removeOwner = function (owner) {

          $scope.recommendation.OwnerList = _.reject($scope.recommendation.OwnerList, { ItemPersonID: owner.ItemPersonID });
        };

        // Select Owner Delegate
        $scope.selectOwnerDelegate = function (person) {

            $scope.recommendation.OwnerDelegate = person;
            $scope.recommendation.OwnerDelegateID = person.ItemPersonID;
            
        };

        // Show Recom info Save Action?
        $scope.showSaveAction = function (form) {
            if (!$scope.recommendation.RecommendationID) return false;
                if (form.$invalid) return false;
                if (_.size($scope.recommendation.OwnerList) === 0) return false;

                return $scope.ctrlCtxt.needSaveChanges;
            };

        // Show Add Action
        $scope.showAddAction = function (form) {
            if ($scope.recommendation.RecommendationID) return false;
            if (form.$invalid) return false;
            if (_.size($scope.recommendation.OwnerList) === 0) return false;

            return $scope.ctrlCtxt.needSaveChanges;
        };

        // Show Delete Action?
        $scope.showDeleteAction = function (form) {
            if (!_.isUndefined($scope.recommendation.RecommendationID) && $scope.recommendation.HasRecommendation_Delete) {
                return true;
            };
        };

        // Toggle Show Long Description
        $scope.toggleExtraDetails = function () {
            $scope.showExtraDetails = !$scope.showExtraDetails;
        };

        // Reset forms
        $scope.reset = function () {
            $state.reload();
        };

        // Create Recommendation
        $scope.createRecommendation = function () {

            $scope.recommendation.RecomObservations = $scope.recommendation.RecomObservations || [];
            if ($scope.recommendation.RecomObservations.length === 0) {
                $scope.recommendation.RecomObservations.push($scope.boxContext.Observation);
            }

            grcRecommendationService
                .createRecommendation($scope.recommendation)
                .then(function (createdRecommendation) {
                    notificationService.notify('Recommendation has been added');
                    $state.go('recommendation.edit', {
                        RecommendationID: createdRecommendation.RecommendationID
                    });
                });
        };

        // Update Recommendation
        $scope.updateRecommendation = function () {

            grcRecommendationService
                .updateRecommendation($scope.recommendation)
                .then(function (updatedRecommendation) {
                    recommendationBeforeChanges = updatedRecommendation;
                    _.assign($scope.recommendation, updatedRecommendation);
                    notificationService.notify('Your changes have been saved');
                    $scope.pageIsNotDirty();
                    $state.reload();
                });
        };

        // Delete Recommendation
        $scope.deleteRecommendation = function () {
            grcRecommendationService
                .deleteRecommendation($scope.recommendation)
                .then(function (deletedRecommendation) {
                    notificationService.notify('Recommendation has been deleted');
                    $scope.clickToBack();
                });
        };

        $scope.getDownloadAttachmentUrl = function (attachmentId) {
            return grcRecommendationService.getDownloadAttachmentUrl($scope.recommendation,
                                                                     attachmentId);
        };

        // Comment
        $scope.viewFollowUps = function () {
            var title = $scope.recommendation.Name;
            var modalScope = followUpService.openRecommendationFollowUpsModal(title,
                                                                $scope.recommendation,
                                                                $scope.currentFollowUps,
                                                                $scope.getDownloadAttachmentUrl);

            modalScope.submitFollowUp = function (followUp) {
                return grcRecommendationService
                            .createRecommendationFollowUp($scope.recommendation,
                                                          followUp)
                            .then(function (followUp) {
                                var newFollowUp = followUp;
                                modalScope.currentFollowUps.unshift(newFollowUp);
                                $scope.currentFollowUps = modalScope.currentFollowUps;
                            });
            };
        };

        // Control
        $scope.goToControl = function (item) {
            $state.go('control', { ControlID: item.ControlID });
        };

        // Go To Observation
        $scope.goToObservation = function (item) {
            historyCtxtService.goToState('observation.edit', {
                    ObservationID: item.ObservationID
                },
                $state.current.name
            )
        };
    }
})();